import { useLocation } from 'react-router-dom'

import { MenuBurger } from '../menu-burger'
import { NextPage } from '../navigation'
import { ProductImageOverlay } from './product-image-overlay.component'
import { MediaCarousel } from './media-carousel.component'

import { IMedia, IUnSdg } from 'src/types'
import { JOURNEY_PAGE_TEMPLATE_ID } from 'src/templates/constants'
import { buildProductNavPaths } from 'src/utils/route.utils'
import { ImageSt, ImageWrapper, MediaContainer } from './product-image.styled'

interface IProps {
  name: string
  image: string
  accountImage?: string
  media: IMedia[]
  unSdg?: IUnSdg[]
  title?: string
  titleFontFamily?: string
  titleFontSize?: string | number
  titleFontWeight?: number | string
  titleBackgroundColor?: string
  titleColor?: string
  nextPageOverride?: {
    to: string
    state?: object
    label?: string
    variant?: 'default' | JOURNEY_PAGE_TEMPLATE_ID
    backgroundColor?: string
    textColor?: string
  }
  menuOverride?: {
    variant?: 'default' | JOURNEY_PAGE_TEMPLATE_ID
    backgroundColor?: string
    textColor?: string
    topOffset?: number
  }
}

export const ProductImage = ({
  name,
  image,
  unSdg,
  media,
  title,
  titleFontFamily,
  titleFontSize,
  titleFontWeight,
  titleBackgroundColor,
  titleColor,
  nextPageOverride,
  menuOverride,
  accountImage,
}: IProps) => {
  const location = useLocation()
  const { journeyPath, productPath } = buildProductNavPaths(location.pathname)

  const defaultState = {
    from: productPath,
    to: journeyPath,
    previousLabel: nextPageOverride?.label || 'Product',
  }

  const nextPageState = nextPageOverride?.state ?? defaultState
  const nextPageTo = nextPageOverride?.to ?? journeyPath

  return (
    <ImageWrapper
      id="index__components-product-image__imagewrapper__l23"
      withIndicator={media.length > 1}
    >
      <MediaContainer id="index__components-product-image__mediacontainer__l70">
        {media.length ? (
          <MediaCarousel media={media} />
        ) : (
          <ImageSt id="index__components-product-image__imagest__l24" alt={name} src={image} />
        )}

        <ProductImageOverlay
          title={title}
          accountImage={accountImage}
          unSdg={unSdg}
          withIndicator={media.length > 1}
          fontFamily={titleFontFamily}
          titleFontSize={titleFontSize}
          titleFontWeight={titleFontWeight}
          titleBackgroundColor={titleBackgroundColor}
          titleColor={titleColor}
        />
      </MediaContainer>
      <MenuBurger {...menuOverride} />
      <NextPage
        to={nextPageTo}
        state={nextPageState}
        label={nextPageOverride?.label}
        variant={nextPageOverride?.variant}
        backgroundColor={nextPageOverride?.backgroundColor}
        textColor={nextPageOverride?.textColor}
      />
    </ImageWrapper>
  )
}
